import styles from "../pages/foryou/_components/MobileComponents/MobileComponents.module.css";
import HiviewerLoader from "./shared/HiviewerLoader";

const LettersLoader = () => {
  return (
    <div className={styles.loaderBg}>
      <HiviewerLoader />
    </div>
  )
}

export default LettersLoader
